import { HttpContextToken, type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize } from 'rxjs';

import { PendingRequestsService } from '../pending-requests.service';

export const SKIP_PENDING_REQUESTS = new HttpContextToken<boolean>(() => false);

@Injectable()
export class PendingRequestsInterceptor implements HttpInterceptor {
  private pendingRequestsService = inject(PendingRequestsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (req.context.get(SKIP_PENDING_REQUESTS)) {
      return next.handle(req);
    }

    this.pendingRequestsService.increment();

    return next.handle(req).pipe(
      finalize(() => {
        this.pendingRequestsService.decrement();
      }),
    );
  }
}
